import a from '@/utils/axios/axios'

const dataTool = {
  namespaced: true,
  state: () => ({
    view: {
      filter: null,
      title: '',
      columns: []
    }
  }),
  mutations: {
    SET_VIEW(state, view) {
      state.view = view
    },
    SET_FILTER(state, filter) {
      state.view.filter = filter
    },
    SET_TITLE(state, title) {
      state.view.title = title
    },
    SET_COLUMNS(state, columns) {
      state.view.columns = columns
    }
  },
  actions: {
    updateDataTool({ rootGetters }, view) {
      return new Promise((resolve, reject) => {
        const team_id = rootGetters['user/currentTeamId']
        const league_id = rootGetters['user/leagueId']

        a.post('/data-tool', {
          ...view,
          team_id,
          league_id
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    fetchGridData({ rootGetters }, request) {
      return new Promise((resolve, reject) => {
        const team_id = rootGetters['user/currentTeamId']
        const league_id = rootGetters['user/leagueId']

        a.post('/data-tool/grid-data', {
          ...request,
          team_id,
          league_id
        })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    saveView({ commit }, view) {
      commit('SET_VIEW', view)
    },
    saveFilter({ commit }, filter) {
      commit('SET_FILTER', filter)
    },
    saveTitle({ commit }, title) {
      commit('SET_TITLE', title)
    },
    saveColumns({ commit }, columns) {
      commit('SET_COLUMNS', columns)
    }
  },
  getters: {
    view: state => state.view,
    filter: state => state.view.filter,
    title: state => state.view.title,
    columns: state => state.view.columns
  }
}

export default dataTool